import { render } from "./NuevoUsuario.vue?vue&type=template&id=16c23aaf&scoped=true"
import script from "./NuevoUsuario.vue?vue&type=script&lang=js"
export * from "./NuevoUsuario.vue?vue&type=script&lang=js"

import "./NuevoUsuario.vue?vue&type=style&index=0&id=16c23aaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c23aaf"]])

export default __exports__